import React, { useCallback, useEffect, useRef, useState } from 'react'
import Button from '../CommonFields/Button'
import { useNavigate } from 'react-router'
import { routesFrontend } from '../RouterFiles/routes'
import CustomerCareSubscriptionPopup from './CustomerCareSubscriptionPopup'
import { getTicketList } from '../../api/customerCare.api';
import { url } from '../../config/url';
import moment from 'moment';
import ListLoader from '../Common/ListLoader';
import { t } from "i18next";
const CustomerCareTicketList = () => {
    const navigate = useNavigate()
    const [showSubscriptionPopup, setSubscriptionPopup] = useState(false)
    const [ticketList, setTicketList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordPerPage, setRecordPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        var isPremium = localStorage?.getItem('premiumUser') || false
        isPremium = isPremium == true || isPremium == "true" ? true : false
        // if(!isPremium) {
        //     setSubscriptionPopup(true)
        // }
    }, [])
    useEffect(() => {
        if (currentPage <= totalPages)
            loadMore()
    }, [currentPage])

    const loadMore = async () => {
        setLoading(true)
        fetchTicketList()
      
    }

    const observer = useRef();
    const lastPostElementRef = useCallback(
        async (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setCurrentPage((prevPage) => prevPage + 1);
                }
            });

            if (node) observer.current.observe(node);
        },
        [loading]
    );

    const fetchTicketList = async () => {
        try {
            const res = await getTicketList({
                "pagination": {
                    "pageNo": currentPage,
                    "recordPerPage": recordPerPage,
                    "sortBy": "createdAt",
                    "sortDirection": "asc"
                }
            });
             setLoading(false)
            if (res?.success && res?.data) {
                setTicketList([...ticketList, ...res?.data])
                setTotalPages(res?.totalPages);
            }
            else {
                setTicketList([]);
            }
        } catch (error) {
            setTicketList([]);
            setLoading(false)
        }
    };

    const checkStatus = (ticket) => {
        if (ticket?.status === "Call Request" || ticket?.status === "Replied" || ticket?.status === "In Progress") {
            return (<span className={`f-12 text-black f-bold bg-inProcess ticket_status_font`} style={{width:"auto"}}>{ticket?.status}</span>)
        }
        else if (ticket?.status === "Rejected") {
            return (<span className={`f-12 text-black f-bold bg-cancelled ticket_status_font`}>{ticket?.status}</span>)
        }
        else if (ticket?.status === "Auto Approved" || ticket?.status=="Approved") {
            return (<span className={`f-12 text-black f-bold bg-completed ticket_status_font`}>{"approved"}</span>)
        }
        return (<span className={`f-12 text-black f-bold bg-pending ticket_status_font`}>{ticket?.status}</span>)
    }

    return (
        <div className='overflow-hidden'>
            <div className='ticket-list scroll-none'>
            {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}

                {
                    ticketList.length > 0 ?
                        ticketList?.map((ticket, index) => (

                            <div className='ticket-box mb-4' onClick={() => navigate('/more/customer-care/ticket/details/' + ticket?._id)} key={index} ref={ticketList?.length === index + 1 ? lastPostElementRef : null}>

                                <div className='d-flex justify-content-between align-items-center'>
                                    <span className='f-14'>ID: #{ticket?.code}</span>
                                    {checkStatus(ticket)}
                                </div>
                                <div className='msg-box mt-3'>
                                    <p className='f-12 mb-0'>{moment(ticket?.createdAt).format('DD/MM/YYYY')}</p>
                                    <p className='f-14 mb-0 description'>{ticket?.description}</p>
                                </div>
                            </div>
                        ))

                        :
                        !loading &&
                        <div className='h-100 w-100 d-flex justify-content-center align-items-center '>
                            <p className='f-14 text-white'>{t("common.no_data_found")}</p>
                        </div>
                  
                }
            </div>
            <div className="main-content registration-main">
          </div>
            <div className='pt-3'>
                <Button text={"raise a complaint"} onClick={() => navigate(routesFrontend.raiseAComplaint)} />
            </div>

            {
                showSubscriptionPopup &&
                <CustomerCareSubscriptionPopup
                    isOpen={showSubscriptionPopup}
                    onClose={() => setSubscriptionPopup(false)} title={"explore vi premium"}
                    onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }} />
            }

        </div>
    )
}

export default CustomerCareTicketList